import ScanbotSDK from "scanbot-web-sdk";

export const createScanbotDocumentSdkAdapter = ({ licenseKey = "" } = {}) => {
  return {
    async initialize() {
      return await ScanbotSDK.initialize({ licenseKey });
    },
  };
};
